import {createAction} from "redux-act";
import {IOddEntity} from "modules/types/odds";

export const fetchOddsByEvent = createAction<number>();
export const fetchOddsByEventSuccess = createAction<IOddEntity>();
export const fetchOddsByEventFailed = createAction();
